module.exports = __webpack_public_path__ + "img/consultoria_9-16_540.919452fc.jpg";